import { Injectable } from '@angular/core';

import type { UnaryFunction } from 'rxjs';
import { pipe, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import type { HttpApiErrorHandlerService } from '@core/http-legacy';
import { AuthorisationStrategy } from '@core/http-legacy';

@Injectable()
export class TellentAdminHttpApiErrorHandlerService implements HttpApiErrorHandlerService {
  public internalServerError$ = new Subject<void>();

  constructor(private authorisationStrategy: AuthorisationStrategy) {}

  public handleError(url: string, preventDefault?: boolean): UnaryFunction<any, any> {
    return pipe(
      catchError(error => {
        if (preventDefault) {
          return throwError(error);
        }

        switch (error.status) {
          case 401:
            this.authorisationStrategy.onUnauthorized(error);
            break;
          case 403:
            this.authorisationStrategy.onForbidden(error);
            break;
          case 500:
            this.internalServerError$.next(error);
            break;
          default:
            break;
        }
        return throwError(error);
      }),
    );
  }
}
